import type { AidPreferenceClessDto } from "../../types/AidPreferenceClessDto";
import type { AidPreferenceClessEntity } from "../../types/AidPreferenceClessEntity";

export const AidPreferenceClessEntityToDto = ({ ...rest }: Readonly<AidPreferenceClessEntity>): AidPreferenceClessDto => {
    return { ...rest };
};
